export const FALTA_DIA_ANTERIOR = 1;
export const FALTA_DIA_SEGUINTE = 2;
export const SOBRA_DIA_ANTERIOR = 3;
export const SOBRA_DIA_SEGUINTE = 4;
export const SOBRA_NAO_IDENTIFICADA = 5;
export const SOBRA_DEVOLUCAO_MERCADORIA = 6;
export const FALTA_NAO_JUSTIFICADA = 7;
export const SOBRA_NO_DEPOSITO = 8;
export const FALTA_NO_DEPOSITO = 9;
export const DEPOSITO_NAO_VINCULADO = 10;
export const DEPOSITO_DUPLICIDADE = 11;
export const ABRIU_TESOURARIA_OPERADOR_DESCONTO = 12;
export const FECHAMENTO_FORCADO = 13;
export const TRANSFERENCIA_TESOURARIA = 14;
export const BLOGUEIRA = 15;
export const VOUCHER = 16;
export const CANCELAMENTO_OP_DESFEITA = 17;
// export const DESCONTO_EM_FOLHA = 18;
export const DESCONTO_EM_FOLHA_POR_OPERADOR = 18;
export const DESCONTO_EM_FOLHA_POR_GERENTE = 34;
export const ERRO_LANCAMENTO_DESPESAS = 19;
export const ERRO_OPERACIONAL = 20;
export const ERRO_SANGRIAS_SUPRIMENTOS = 21;
export const ERRO_SISTEMA = 22;
export const ERRO_CONTAGEM = 23;
export const CANCELAMENTO_FATURA_AVENIDA = 24;
export const SINISTRO_FRAUDE = 25;
export const VALOR_NAO_EXCEDE_LIMITE_5 = 26;
export const LOJA_FECHADA = 27;
export const TESTE_DE_INAUGURACAO = 28;
export const NOTA_FALSA = 29;
export const TROCO = 30;
export const TROCO_ENTRE_OPERADORES = 31;
export const CONVERSAO_MOEDAS = 32;
